var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextButton',{staticClass:"px-0",on:{"click":_vm.handleClick}},[(_vm.hidden)?[_c('v-icon',[_vm._v("mdi-eye")])]:[_c('v-icon',[_vm._v("mdi-eye-off")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }